import { Link } from "react-router-dom";
import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Row = { matterId: string; draftCount: number; deadlineCount: number };

export default function MattersPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ matters: Row[] }>("/api/v1/tenant/matters");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("matters.title")}</h1>
      <DataTable
        rows={data?.matters ?? null}
        loading={loading}
        error={error}
        empty={t("matters.empty")}
        columns={[
          {
            header: t("matters.col.id"),
            render: (r) => (
              <Link className="text-brand-700 hover:underline" to={`/admin/matters/${encodeURIComponent(r.matterId)}`}>
                {r.matterId}
              </Link>
            ),
          },
          { header: t("matters.col.drafts"), render: (r) => r.draftCount },
          { header: t("matters.col.deadlines"), render: (r) => r.deadlineCount },
        ]}
      />
    </div>
  );
}
